import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["src"]

import { computed, watch } from 'vue'
import { serverConfig } from '@/shared/config/serverConfig/serverConfig'


export default /*#__PURE__*/_defineComponent({
  __name: 'YandexMetrika',
  setup(__props) {

const yandexMetrikaId = computed(() => serverConfig.value?.yandexMetrikaId)
const isNotDev = computed(() => yandexMetrikaId.value && yandexMetrikaId.value !== 'ym_id')

function init() {
	if (isNotDev.value && yandexMetrikaId.value) {
		// noinspection TypeScriptLibrary
		(function(m, e, t, r, i, k, a) {
			m[i] = m[i] || function() {
				// eslint-disable-next-line prefer-rest-params
				(m[i].a = m[i].a || []).push(arguments)
			}
			m[i].l = 1 * new Date()
			k = e.createElement(t), a = e.getElementsByTagName(t)[0], k.async = 1, k.src = r, a.parentNode.insertBefore(k, a)
		})
		(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym')

		// eslint-disable-next-line no-undef
		ym(yandexMetrikaId.value, 'init', {
			clickmap: true,
			trackLinks: true,
			accurateTrackBounce: true,
			webvisor: true
		})
	}
}

watch(isNotDev, (newValue) => {
	if (newValue) {
		init()
	}
})

watch(yandexMetrikaId, (newValue) => {
	if (newValue) {
		init()
	}
})

return (_ctx: any,_cache: any) => {
  return (_unref(isNotDev) && _unref(yandexMetrikaId))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("img", {
          src: 'https://mc.yandex.ru/watch/' + _unref(yandexMetrikaId),
          style: {"position":"absolute","left":"-9999px"},
          alt: ""
        }, null, 8, _hoisted_2)
      ]))
    : _createCommentVNode("", true)
}
}

})